/*
 * Отложенная загрузка картинок с data-src (и data-srcset) и фонов с data-bg: адрес
 * подставляется, когда элемент подъезжает к экрану.
 *
 * Раньше src выставлялся всем сразу в расчёте на loading="lazy". Но на медленном
 * соединении Chrome начинает грузить «ленивые» картинки за 2500px до экрана — то есть
 * почти всё, что на странице ниже первого экрана, и именно тогда, когда канал нужен
 * главной картинке. Свой порог (MARGIN) от скорости сети не зависит. Картинка в скрытом
 * блоке (display: none) с вьюпортом не пересекается и не грузится вовсе.
 */
const MARGIN = '800px 0px';

const load = (img) => {
  if (img.dataset.srcset) {
    img.srcset = img.dataset.srcset;
  }
  img.src = img.dataset.src;
};

// Слайдер, внутри которого лежит картинка: Swiper хранит экземпляр в свойстве элемента.
const findSwiper = (el) => {
  for (let node = el.parentElement; node; node = node.parentElement) {
    if (node.swiper) {
      return node.swiper;
    }
  }
  return null;
};

const PENDING = 'img[data-src]:not([src]), [data-bg]';

const show = (el) => {
  // Фон: инлайновый background-image браузер качает сразу, где бы блок ни находился.
  if (el.dataset.bg) {
    el.style.backgroundImage = `url("${el.dataset.bg}")`;
    el.removeAttribute('data-bg');
    return;
  }
  // Размеры слайда могут зависеть от картинки — после загрузки слайдер пересчитывается.
  el.addEventListener('load', () => {
    const swiper = findSwiper(el);
    swiper && swiper.update();
  }, { once: true });
  load(el);
};

let observer = null;

const onIntersect = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    }
    const el = entry.target;
    observer.unobserve(el);
    show(el);

    // В слайдере соседние слайды обрезаны и сами в зону видимости не попадут, пока до них
    // не долистают: грузим их заранее, чтобы при перелистывании не было пустого слайда.
    const slide = el.closest('.swiper-slide');
    slide && [slide.previousElementSibling, slide.nextElementSibling].forEach((neighbour) => {
      if (!neighbour) {
        return;
      }
      [neighbour, ...neighbour.querySelectorAll(PENDING)].filter((other) => other.matches(PENDING)).forEach((other) => {
        observer.unobserve(other);
        show(other);
      });
    });
  });
};

// root — куда смотреть: после подгрузки списка (см. articles.js) достаточно нового куска.
export function processLazyImages(root = document) {
  const pending = root.querySelectorAll(PENDING);

  if (!('IntersectionObserver' in window)) {
    pending.forEach(show);
    return;
  }

  observer = observer || new IntersectionObserver(onIntersect, { rootMargin: MARGIN });
  pending.forEach((el) => observer.observe(el));
}

processLazyImages();
